// Import Module Specific Scripts
import { initCaseStudyCursorTracker } from './homepage-case-studies-section/js';
import { initFixedBackground } from './homepage-fixed-background/js';
import { initMobileDesignsGallerySection } from './content-builder-mobile-designs-gallery-section/js';
import { initHomepageHeroSection } from './homepage-hero-section/js';

// -----------------------------------------------------------------------------

export const initModules = () => {
  initCaseStudyCursorTracker();
  initFixedBackground();
  initMobileDesignsGallerySection();
  initHomepageHeroSection();
};
